if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){


    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: true
    });

    $('.gallery-right-js').slick({
        accessibility: true
    });
    $('.gallery-center-js').slick({
        accessibility: true
    });
    $('.gallery-left-js').slick({
        accessibility: true
    });
    $('.reviews').slick({
        fade:true,
        accessibility: true,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    arrows:false,
                    dots: true,
                    adaptiveHeight:true
                }
            }
        ]
    })

    // List filter desktop
    const list_btns = document.querySelectorAll('.filter-list__button');
    const list_items = document.querySelectorAll('.filter-list__item');
    if(list_btns){
        for(let i = 0; i < list_btns.length; i++){
            list_btns[i].addEventListener('click', function(){
                if(this.closest('.filter-list__item').classList.contains('active')){
                    this.closest('.filter-list__item').classList.remove('active');
                }else{
                    for(let a = 0; a < list_items.length; a++){
                        list_items[a].classList.remove('active');
                    }
                    this.closest('.filter-list__item').classList.add('active');
                }
            })
        } 
    }

    if($('.filter-list__filter').length > 0){
        $('.filter-list__filter ul li').click(function(){
            const thisTag = $(this).attr('data-tag');
            if(thisTag != 'all'){
                $('.filter-list__container .filter-list__item').hide();
                $('.filter-list__container .'+thisTag).fadeIn();
                $('.filter-list__filter ul li').removeClass('active');
                $(this).addClass('active');
            }else{
                $('.filter-list__container .filter-list__item').fadeIn();
                $('.filter-list__filter ul li').removeClass('active');
                $(this).addClass('active');
            }
        });
    }

    if(document.querySelector('.filter-list__filter')){
        const filter_tab = document.querySelectorAll('.filter-list__filter ul li'); filter_tab[filter_tab.length - 1].click();
    }

    // List filter mobile
    if($('.filter-list__filter-mobile').length > 0){
        $('#filter-tabs-list').on('change', function () {
            const thisTag = $(this).val();
            if(thisTag != 'all'){
                $('.filter-list__container .filter-list__item').hide();
                $('.filter-list__container .'+thisTag).fadeIn();
            }else{
                $('.filter-list__container .filter-list__item').fadeIn();
            }
        });
    }

	if ($('#filter-tabs-list').length > 0) {
		$('#filter-tabs-list').val('all').trigger('change');
	}


})();